import purchaseDeletedFullcont from './purchaseDeleted-fullcont.html'

const fullcontEntity          = require('../../../../../components/fullcont/fullcont-entity')
const fullcontHandler         = require('../../../../../components/fullcont/fullcont-handler')
const handler                 = require('./purchaseDeleted-fullcont-handler')
const calculateHandler        = require('./purchaseDeleted-fullcont-calculate-handler')
const purchaseDeletedDtsimple = require('./purchaseDeleted-fullcont-dtSimple')
const purchaseDeletedMenu     = require('./purchaseDeleted-menu')
const { form, formCopy }      = require('./purchaseDeleted-fullcont-form')
const { purchaseMT }          = require('./purchaseDeleted-fullcont-multitable')


/****************ELEMENTS*****************/
var htmlFc = {}
var HTMLwasSelected = false

function HTMLselect(detail) {

  fullcontHandler.HTMLselect(
    'purchaseDeleted',
    'purchaseDeleted',
    'purchaseDeleted-fullcont',
    purchaseDeletedFullcont, form, formCopy, purchaseMT,
    readOnlyAction, readOnlyAction, undefined, htmlFc
  )

  htmlFc.fullcontHTML.classList.add('mode-readOnly', 'mode-view')
  HTMLwasSelected = true
}
/**/


export function start(detail) {

  if (!HTMLwasSelected) { HTMLselect(detail) }

  obj[detail.act].start(detail)
}
/**/


const obj = {

  fullcontOptions: { start: (detail) => { purchaseDeletedMenu.start(detail, 'htmlDt', htmlFc) } },
  hide:            { start: (detail) => { fullcontEntity.hide(detail, htmlFc) } },
  restore:         { start: (detail) => { handler.restorePurchase(htmlFc) } },
  selectOne:       { start: (detail) => { selectOne(detail, htmlFc) } }

}


function selectOne(detail, htmlFc) {

  fullcontEntity.selectOne(detail, htmlFc, processAfterSelectOne)
}
/**/


function processAfterSelectOne(data, result) {

  handler.dtgenerator(result, htmlFc)
  handler.itemWithSale(result, htmlFc)
  calculateHandler.fill_InventoryStock_spentCredit(data)
  calculateHandler.calculate_total_lost_returned()
  handler.showLost()
  handler.showReturnMtItem(true)
  handler.fillInputReturnMtItem()
  calculateHandler.calculateInvoiceTotal(result, htmlFc)
  purchaseDeletedDtsimple.fillItemsChatTable(result, htmlFc)
  enforceReadOnly()
}
/**/


function enforceReadOnly() {

  htmlFc.fullcontHTML.classList.add('mode-view', 'mode-readOnly')
  htmlFc.fullcontHTML.classList.remove('mode-edit', 'mode-add')

  const filePage = htmlFc.fullcontHTML.querySelector('.filePage')

  htmlFc.fullcontHTML.querySelectorAll('input, select, textarea, button').forEach((element) => {
    if (filePage?.contains(element)) return

    element.disabled = true
    element.setAttribute('readonly', 'readonly')
  })

  htmlFc.fullcontHTML
    .querySelectorAll('.fab-to-edit, .fab-to-add, .fab-to-update, .fab-to-readOnly, .more, .removeLine, .btn')
    .forEach((element) => {
      if (filePage?.contains(element)) return

      element.classList.add('dn')
    })

  filePage?.querySelectorAll('input, select, textarea, button').forEach((element) => {
    element.disabled = false
    element.removeAttribute('readonly')
  })
}
/**/


function readOnlyAction() {

  return false
}
